import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { THEME } from '../constants/theme';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);

const InteractionChart = ({ data, type = 'line', title }) => {
  const chartData = {
    datasets: [
      {
        label: title,
        data: data,
        borderColor: THEME.primary,
        backgroundColor: `${THEME.primary}20`,
        fill: true,
        tension: 0.4
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: title,
        color: THEME.text,
        font: {
          size: 16,
          weight: 'bold'
        }
      }
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day'
        },
        grid: {
          display: false
        },
        ticks: {
          color: THEME.subtext
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: `${THEME.subtext}10`
        },
        ticks: {
          color: THEME.subtext,
          precision: 0
        }
      }
    }
  };

  return (
    <div className="h-64 w-full">
      {type === 'line' ? (
        <Line data={chartData} options={options} />
      ) : (
        <Bar data={chartData} options={options} />
      )}
    </div>
  );
};

export default InteractionChart; 